import React from 'react';
import { Box, IconButton } from '@mui/material';
import { type MuiEvent, type GridCellParams } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';

interface ActionButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  row: any;
  actionBtnText1?: string;
  actionBtnText2?: string;
  actionBtnText3?: string;
  ActionBtnIcon1?: React.ElementType;
  ActionBtnIcon2?: React.ElementType;
  ActionBtnIcon3?: React.ElementType;
  onActionBtnClick1?: (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent<HTMLElement>>,
  ) => void;
  onActionBtnClick2?: (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent<HTMLElement>>,
  ) => void;
  onActionBtnClick3?: (params: GridCellParams) => void;
  disableCondition?: boolean;
}

const CustomTableActionButton: React.FC<ActionButtonProps> = ({
  row,
  actionBtnText1,
  actionBtnText2,
  actionBtnText3,
  ActionBtnIcon1,
  ActionBtnIcon2,
  ActionBtnIcon3,
  onActionBtnClick1,
  onActionBtnClick2,
  onActionBtnClick3,
  disableCondition,
}) => {
  const handleButtonClick1 = (
    event: MuiEvent<React.MouseEvent<HTMLElement>>,
  ): void => {
    if (onActionBtnClick1) {
      onActionBtnClick1(row, event);
    }
  };
  const handleButtonClick2 = (
    event: MuiEvent<React.MouseEvent<HTMLElement>>,
  ): void => {
    if (onActionBtnClick2) {
      onActionBtnClick2(row, event);
    }
  };
  const handleButtonClick3 = (
    event: MuiEvent<React.MouseEvent<HTMLElement>>,
  ): void => {
    if (onActionBtnClick3) {
      onActionBtnClick3(row, event);
    }
  };

  return (
    <Box
      width="60%"
      m="0 auto"
      p="5px"
      display="flex"
      justifyContent="space-between"
    >
      {ActionBtnIcon1 && (
        <IconButton onClick={handleButtonClick1} aria-label={actionBtnText1}>
          {ActionBtnIcon1 ? <ActionBtnIcon1 /> : <EditIcon />}
        </IconButton>
      )}
      {ActionBtnIcon2 && (
        <IconButton
          onClick={handleButtonClick2}
          disabled={disableCondition ?? false}
          aria-label={actionBtnText2}
        >
          <ActionBtnIcon2 />
        </IconButton>
      )}
      {ActionBtnIcon3 && (
        <IconButton onClick={handleButtonClick3} aria-label={actionBtnText3}>
          {ActionBtnIcon3 ? <ActionBtnIcon3 /> : <EditIcon />}
        </IconButton>
      )}
    </Box>
  );
};

export default CustomTableActionButton;
